import { PRIMARY_COLOR, MAIN_COLOR, SECONDARY_COLOR, TERNARY_COLOR, ACCENT_ERROR, ACCENT_INFO, ICON_COLOR, SHADE_COLOR, EXTRA_VARIANT, CARD_SECONDARY_COLOR, COMMON_DEFAULT, INPUT_TEXT_COLOR, OUTLINE_PRIMARY, OUTLINE_SECENDARY, ICON_LIGHT, GOLD_HIGHLIGHT, LIGHT_ASH, QUATERARY_COLOR, TEXT_SECONDARY_COLOR, TEXT_PRIMARY_COLOR, TEXT_TERNARY_COLOR, GOLD_HIGHLIGHT_LIGHT } from "./colors";

const palette = {
    primary: {
        main: PRIMARY_COLOR,
        contrastText: COMMON_DEFAULT
    },
    secondary: {
        main: SECONDARY_COLOR,
        contrastText: COMMON_DEFAULT
    },
    ternary: {
        main: TERNARY_COLOR,
        contrastText: COMMON_DEFAULT
    },
    queternary: {
        main: MAIN_COLOR,
        contrastText: COMMON_DEFAULT
    },
    quinary: {
        main: QUATERARY_COLOR,
        contrastText: COMMON_DEFAULT
    },
    error: {
        main: ACCENT_ERROR,
        contrastText: COMMON_DEFAULT
    },
    info: {
        main: ACCENT_INFO,
        contrastText: COMMON_DEFAULT
    },
    success: {
        main: PRIMARY_COLOR,
        contrastText: COMMON_DEFAULT
    },
    disabled: {
        main: SHADE_COLOR,
        contrastText: COMMON_DEFAULT
    },
    icons: {
        main: ICON_COLOR,
        light: ICON_LIGHT,
        contrastText: COMMON_DEFAULT,
        lightAsh: LIGHT_ASH,
        highlighter: GOLD_HIGHLIGHT,
        highlight: GOLD_HIGHLIGHT_LIGHT
    },
    text: {
        primary: MAIN_COLOR,
        secondary: ICON_COLOR,
        disabled: MAIN_COLOR,
    },
    divider: SHADE_COLOR,
    background: {
        paper: COMMON_DEFAULT,
        default: EXTRA_VARIANT
    },
    cards: {
        main: CARD_SECONDARY_COLOR,
        contrastText: MAIN_COLOR
    },
    textcolor: {
        main: INPUT_TEXT_COLOR,
        contrastText: MAIN_COLOR
    },
    buttoncolor: {
        main: OUTLINE_PRIMARY,
        contrastText: OUTLINE_SECENDARY
    },
    textSecondary: {
        main: TEXT_PRIMARY_COLOR,
        light: TEXT_SECONDARY_COLOR,
        dark: TEXT_TERNARY_COLOR
    }
};

export default palette;